import { render, staticRenderFns } from "./option.vue?vue&type=template&id=5953ba9d&scoped=true&"
import script from "./option.vue?vue&type=script&lang=ts&"
export * from "./option.vue?vue&type=script&lang=ts&"
import style0 from "./option.vue?vue&type=style&index=0&id=5953ba9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5953ba9d",
  null
  
)

export default component.exports